const faqData = [
    {
      question: {
         "en" : "What’s the nearest MRT station?",
         "zh-tw" : "請問最近的地鐵站是哪一站？ ",
         "zh" : "请问最近的地铁站是哪一站？"
        },
      answer: {
          "en" : "VingaHall@RG is 1 minute from Farrer Park MRT, and VingaHall@BK is 7 minutes from Boon Keng MRT. ",
          "zh-tw" : "您好，VingaHall@RG 距離花拉公園地鐵站步行約1分鐘，VingaHall@BK 則距離文慶地鐵站約7分鐘，交通非常便利！ ",
          "zh" : "您好，VingaHall@RG 距离花拉公园地铁站步行约1分钟，VingaHall@BK 则距离文庆地铁站约7分钟，交通非常便利！ "
      },
    },
    {
      question: {
         "en" : "Can I see room photos of VingaHall@RG and VingaHall@BK?",
         "zh-tw" : "我可以看看VingaHall@RG和VingaHall@BK的房型照片嗎？ ",
         "zh" : "我可以看看VingaHall@RG和VingaHall@BK的房型照片吗？ "
        },
      answer: {
          "en" : "VingaHall@RG is 1 minute from Farrer Park MRT, and VingaHall@BK is 7 minutes from Boon Keng MRT. ",
          "zh-tw" : `當然可以！請點選下方連結查看實拍照片：<br />  <a href="">VingaHall@RG</a> <br/> <a href="" >VingaHall@BK</a>`,
          "zh" : `当然可以！请点选下方连结查看实拍照片：<br /> <a href="">VingaHall@RG</a> <br/> <a href="" >VingaHall@BK</a>`
      },
    },
    {
      question: {
         "en" : "What’s the difference between Boarding House (Meal Plan) and Room For Rent (Room-Only Plan)? ",
         "zh-tw" : "想了解寄宿（含餐）与住宿（不含餐）的方案差别？",
         "zh" : "想了解寄宿（含餐）与住宿（不含餐）的方案差别？"
        },
      answer: {
          "en" : "Boarding House (Meal Plan) includes weekday breakfast & dinner, and 3 meals on weekends. Room For Rent (Room-Only Plan) requires students to manage their own meals.",
          "zh-tw" : "寄宿（含餐）提供平日早晚餐與週末三餐；住宿（不含餐）則需自理飲食。",
          "zh" : "寄宿（含餐）提供平日早晚餐与周末三餐；住宿（不含餐）则需自理饮食。 "
      },
    },
    {
      question: {
         "en" : "Do you have a pricing table?",
         "zh-tw" : "有價格表嗎？ ",
         "zh" : "有价格表吗？ "
        },
      answer: {
          "en" : `Yes! Please click below to view the latest pricing table. <br />

          <a href="">VingaHall@RG</a> <br/> <a href="" >VingaHall@BK</a>`,
          "zh-tw" : `請點選下方連結查看最新價格表： <br />

          <a href="">VingaHall@RG</a> <br/> <a href="">VingaHall@BK</a>`,
          "zh" : `请点选下方连结查看最新价格表：<br />

          <a href="">VingaHall@RG</a> <br/> <a href="">VingaHall@BK</a>`
      },
    },
    {
      question: {
         "en" : "Are laundry and cleaning services provided? ",
         "zh-tw" : "有洗衣、打掃服務嗎？ ",
         "zh" : "有洗衣、打扫服务吗？ "
        },
      answer: {
          "en" : "Yes. We offer bi-weekly laundry and cleaning services.",
          "zh-tw" : "有的！每週兩次洗衣與兩次房間清潔服務，讓您輕鬆生活無負擔。 ",
          "zh" : "有的！每周两次洗衣与两次房间清洁服务，让您轻松生活无负担。"
      },
    },
    {
      question: {
         "en" : "Do you have hostel manager? ",
         "zh-tw" : "有宿舍管理員嗎？ ",
         "zh" : "有宿舍管理员吗？ "
        },
      answer: {
          "en" : "Yes, we provide 24/7 hostel supervision, supporting students with daily routines, adjustment to hostel life, and overall well-being. ",
          "zh-tw" : "我們提供24小時宿舍管理服務，協助學生適應新環境、管理日常起居與學習生活。 ",
          "zh" : "我们提供24小时宿舍管理服务，协助学生适应新环境、管理日常起居与学习生活。 "
      },
    },
    {
      question: {
         "en" : "Can you help with airport pickup? ",
         "zh-tw" : "可以協助安排接機服務嗎？ ",
         "zh" : "可以协助安排接机服务吗？"
        },
      answer: {
          "en" : "Absolutely! Just send us your flight details in advance. ",
          "zh-tw" : "當然可以！請提前提供航班資訊，我們會協助安排接機服務。 ",
          "zh" : "当然可以！请提前提供航班资讯，我们会协助安排接机服务。 "
      },
    },
    {
      question: {
         "en" : "How can I schedule a hostel visit? ",
         "zh-tw" : "我想預約參觀宿舍，怎麼操作？ ",
         "zh" : "我想预约参观宿舍，怎么操作？ "
        },
      answer: {
          "en" : "We’d love to welcome you! Please contact us to arrange a visit, and our staff will provide a guided tour and answer any questions you may have. ",
          "zh-tw" : "歡迎參觀！請直接與我們聯繫預約，將為您安排專人導覽宿舍環境並解說相關資訊。 ",
          "zh" : "欢迎参观！请直接与我们联系预约，将为您安排专人导览宿舍环境并解说相关资讯。 "
      },
    },
  ];
  
  export default faqData;
  